import React from "react";
import { Link } from "react-router-dom";
import { Search, Bell, MessageCircle, Plus } from "lucide-react";

export default function TopBar({ title, setSidebarOpen, initials, notifCount, setNotifCount }) {
  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center px-3 sm:px-5 gap-3 flex-shrink-0 z-30">
      <button onClick={() => setSidebarOpen(true)} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-lg lg:hidden">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <h1 className="text-lg font-bold text-gray-900">{title}</h1>

      <div className="flex-1 max-w-sm mx-4 hidden sm:flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2">
        <Search className="w-4 h-4 text-gray-400 flex-shrink-0" />
        <input
          placeholder="Search loads, drivers, routes..."
          className="flex-1 bg-transparent text-sm text-gray-600 placeholder-gray-300 outline-none min-w-0"
        />
      </div>

      <div className="ml-auto flex items-center gap-1 sm:gap-3">
        <button
          onClick={() => setNotifCount(0)}
          className="relative w-9 h-9 hover:bg-gray-100 rounded-xl flex items-center justify-center text-gray-500 transition-colors"
        >
          <Bell className="w-5 h-5" />
          {notifCount > 0 && (
            <span className="absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center">
              {notifCount}
            </span>
          )}
        </button>

        <button className="w-9 h-9 hover:bg-gray-100 rounded-xl items-center justify-center text-gray-500 hidden sm:flex transition-colors">
          <MessageCircle className="w-5 h-5" />
        </button>

        <Link to="/post-load">
          <button
            className="hidden sm:flex items-center gap-1.5 text-white text-xs font-bold px-3 py-2 rounded-xl transition-colors hover:opacity-90"
            style={{ background: "#1a2744" }}
          >
            <Plus className="w-3.5 h-3.5" /> Post Load
          </button>
        </Link>

        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0" style={{ background: "#1a2744" }}>
            {initials}
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-semibold text-gray-800 leading-tight">Company</p>
            <div className="flex items-center gap-1">
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />
              <span className="text-xs text-green-600">Active</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}